import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import WaitlistForm from "./WaitlistForm";

export default function WaitlistModal({ open, onClose, defaultPersona }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          data-testid="waitlist-modal"
        >
          <div
            className="absolute inset-0 bg-ink/80 backdrop-blur-sm"
            onClick={onClose}
          />
          <motion.div
            className="relative z-10 w-full max-w-md rounded-2xl border border-white/10 bg-void p-7 shadow-2xl"
            initial={{ opacity: 0, y: 24, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.97 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          >
            <button
              onClick={onClose}
              className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full text-mute transition-colors hover:bg-white/5 hover:text-paper"
              data-testid="waitlist-modal-close"
              aria-label="Close"
            >
              <X size={18} />
            </button>

            <p className="overline">Early access</p>
            <h2 className="mt-2 font-display text-3xl leading-tight text-paper">
              Join the Smritium waitlist
            </h2>
            <p className="mt-2 mb-6 text-sm text-mute">
              Be first to run the sovereign memory layer. Enterprise design
              partners get priority onboarding.
            </p>

            <WaitlistForm defaultPersona={defaultPersona} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
